export { default } from './Characteristics';
